  import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
  import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
  import { CommonService } from '../../../services/common.service';
  import { LangService } from 'src/app/core/services/lang.service';
  import { GridService } from 'src/app/shared/services/grid.service';

  @Component({
    selector: 'app-cost-center-list',
    templateUrl: './../../../templates/forms/modals/bank-name-list.component.html',
  })
  export class BankNameListComponent implements OnInit {


    @Input()
    modalShow: boolean = true;

    @Input()
    MULTICOMPANY_CHART;

    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "BankNameListGrid"

    dataObj: any;
    bankNameList: any[] = [];
    searchFields: any[] = ['BRANCH_NAME', 'BANK_ACC_NO', 'ACC_NAME', 'BANKDTL_NO'] // , 'ACC_NO', 'ACC_NAME', 'BRANCH_ADDR', 'BANKDTL_NO'
    public searchString;
    constructor(private dataService: CommonService,
      public langService: LangService,
      public gridService: GridService) {
      this.colObj = [
        { headerName: langService.langData.branchNameCap, field: 'BRANCH_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.bankAccNoCap, field: 'BANK_ACC_NO', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.accNameCap, field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.branchAddressCap, field: 'BRANCH_ADDR', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.bankDTLNo, field: 'BANKDTL_NO', sortable: true, resizable: true, hide: false },
      ];
    }

    ngOnInit() {
      this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
      this.grid = grid;
      this.gridService.sizeColumnsToFit(grid, this.gridId);
      if (this.MULTICOMPANY_CHART == 1) {
        this.dataService.getMultiAccInfo()
          .subscribe(arg => { this.bankNameList = arg.body });
      } else {
        this.dataService.getBankAccountNames()
          .subscribe(arg => { this.bankNameList = arg.body });
      }
    }
    itemClick(_item) {
      this.modalShow = false;
      this.dataObj = _item;
      this.submit.next();
    }
  }
